import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import { contentContext } from "../../context/contentContext";
import clockIcon from "../../assets/images/clock-icon.svg";
import cpcClock from "../../assets/images/icons/cpc-clock.svg";
import slotIcon from "../../assets/images/slot-icon.svg";
import calendar from "../../assets/images/icons/calendar.svg";
import cpcCalendar from "../../assets/images/icons/cpc-calendar.svg";
import tmdbApi from "../../api/tmdbApi";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
// let { RAZORPAY_KEY_ID } = window.app;
// import rotate_right from "../../assets/images/rotate_right-1.svg"

import rotate_right from '../../assets/images/rotate_right.svg';
import rotate_right_cpc from '../../assets/images/rotate_right_cpc.svg';



const DescCPCBlock = ({ quizInfo, getCpcInfo, timer }) => {
    const navigate = useNavigate();
    dayjs.extend(utc);
    dayjs.extend(timezone);
    const token = localStorage.getItem("token");
    const location = useLocation();
    const [error, setError] = useState("Pre-CPC Quiz of the month");
    const [successMsgDisplay, setSuccessDisplay] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState(false);
    const [isEnabled, setIsEnabled] = useState(false);
    const [loading, setloading] = useState(false);
    const [isCPCEnabled, setIsCPCEnabled] = useState(false);
    const [isCPCStarted, setIsCPCStarted] = useState(false);
    const [isCPCEnded, setIsCPCEnded] = useState(false);
    const { userData } = useContext(contentContext)
    const [showAlert, setShowAlert] = useState(false);
    const [timeZone, setTimeZone] = useState("Asia/Kolkata")
    const [razorpayKey, setRazorpayKey] = useState(null);
    const [showWaiting, setShowWaiting] = useState(false);
const [alertTitle, setAlertTitle] = useState("");
    const okayErrorFn = () => {
        setErrorMsg(false);
        getCpcInfo();


    }
    // useEffect(() => {
    //     console.log("DescCPCBlock mounted or quizInfo changed");
    //     console.log("quizInfo:", quizInfo);

    //     const fetchConfig = async () => {
    //         console.log("Fetching Razorpay config...");
    //         const response = await tmdbApi.configData();
    //         console.log("Config response:", response);

    //         if (response?.result && response?.result.length > 0) {
    //             console.log("Razorpay Key Found:", response?.result[0]?.RAZORPAY_KEY_ID);
    //             setRazorpayKey(response?.result[0]?.RAZORPAY_KEY_ID);
    //         }
    //     };
    //     fetchConfig();

    //     if (!quizInfo) return;

    //     const cpcEnableCheck = () => {
    //         console.log("Running CPC Enable Check...");

    //         const {
    //             scheduleDate,
    //             scheduleEndDate,
    //             scheduleStartTime,
    //             scheduleEndTime
    //         } = quizInfo;

    //         if (!scheduleDate || !scheduleEndDate || !scheduleStartTime || !scheduleEndTime) {
    //             console.warn("Missing required CPC schedule fields.");
    //             return;
    //         }

    //         const zone = timeZone || "Asia/Kolkata";
    //         console.log("Timezone used:", zone);

    //         const startDatePart = scheduleDate.split("T")[0];
    //         const endDatePart = scheduleEndDate.split("T")[0];

    //         const sstartTime = dayjs.tz(`${startDatePart} ${scheduleStartTime}`, "YYYY-MM-DD HH:mm", zone);
    //         const sendTime = dayjs.tz(`${endDatePart} ${scheduleEndTime}`, "YYYY-MM-DD HH:mm", zone);
    //         const now = dayjs().tz(zone);

    //         console.log("CPC Start:", sstartTime.format());
    //         console.log("CPC End:", sendTime.format());
    //         console.log("Current Time:", now.format());

    //         setIsCPCEnabled(now.isAfter(sstartTime) && now.isBefore(sendTime));
    //         setIsCPCEnded(now.isAfter(sendTime));
    //     };

    //     const checkTime = () => {
    //         console.log("Checking meeting time...");

    //         const { meetingDate, meetingStartTime, meetingEndTime, reserved } = quizInfo;

    //         if (!meetingDate || !meetingStartTime || !meetingEndTime) {
    //             console.warn("Meeting date/time missing");
    //             return;
    //         }

    //         const zone = timeZone || "Asia/Kolkata";
    //         const datePart = meetingDate.split("T")[0];

    //         let startTime = dayjs.tz(`${datePart} ${meetingStartTime}`, "YYYY-MM-DD HH:mm", zone);

    //         if (quizInfo?.reserved) {
    //             console.log("User reserved, subtracting 5 mins");
    //             startTime = startTime.subtract(5, 'minute');
    //         }

    //         const endTime = dayjs.tz(`${datePart} ${meetingEndTime}`, "YYYY-MM-DD HH:mm", zone);
    //         const now = dayjs().tz(zone);

    //         console.log("Meeting Start:", startTime.format());
    //         console.log("Meeting End:", endTime.format());
    //         console.log("Now:", now.format());

    //         const today = now.startOf("day");
    //         const meetingDay = dayjs(meetingDate).tz(zone).startOf("day");

    //         setIsEnabled(today.isSame(meetingDay));
    //         setIsCPCStarted(!reserved && now.isAfter(startTime));

    //         cpcEnableCheck();
    //     };
    //     if (!quizInfo.reserved && location?.pathname === "/cpcregistration") {
    //         setError("Please Reserve your spot");
    //     } else if (!quizInfo.reserved) {
    //         setError("Please Reserve your spot");
    //     } else if (quizInfo.participated && quizInfo.reserved) {
    //         setError("You have already participated");
    //     }

    //     checkTime();
    //     const interval = setInterval(checkTime, 1000);
    //     return () => clearInterval(interval);
    // }, [quizInfo]);
   
   useEffect(() => {
    console.log("DescCPCBlock mounted or quizInfo changed");
    console.log("quizInfo:", quizInfo);

    if (!quizInfo) return;

    // Fetch Razorpay config
    const fetchConfig = async () => {
        console.log("Fetching Razorpay config...");
        try {
            const response = await tmdbApi.configData();
            console.log("Config response:", response);

            if (response?.result && response?.result.length > 0) {
                console.log("Razorpay Key Found:", response?.result[0]?.RAZORPAY_KEY_ID);
                setRazorpayKey(response?.result[0]?.RAZORPAY_KEY_ID);
            }
        } catch (err) {
            console.error("Error fetching config:", err);
        }
    };
    fetchConfig();

    const zone = timeZone || "Asia/Kolkata";

    // -------------------------------
    // CPC Enable / End check
    // -------------------------------
    const cpcEnableCheck = () => {
        const { scheduleDate, scheduleEndDate, scheduleStartTime, scheduleEndTime } = quizInfo;

        if (!scheduleDate || !scheduleEndDate || !scheduleStartTime || !scheduleEndTime) return {};

        const startDatePart = scheduleDate.split("T")[0];
        const endDatePart = scheduleEndDate.split("T")[0];

        const sstartTime = dayjs.tz(`${startDatePart} ${scheduleStartTime}`, "YYYY-MM-DD HH:mm", zone);
        const sendTime = dayjs.tz(`${endDatePart} ${scheduleEndTime}`, "YYYY-MM-DD HH:mm", zone);
        const now = dayjs().tz(zone);

        setIsCPCEnabled(now.isAfter(sstartTime) && now.isBefore(sendTime));
        setIsCPCEnded(now.isAfter(sendTime));

        return { now, sstartTime, sendTime };
    };

    // -------------------------------
    // Meeting check
    // -------------------------------
    const checkMeetingTime = () => {
        const { meetingDate, meetingStartTime, meetingEndTime, reserved } = quizInfo;

        if (!meetingDate || !meetingStartTime || !meetingEndTime) return {};

        const datePart = meetingDate.split("T")[0];

        let startTime = dayjs.tz(`${datePart} ${meetingStartTime}`, "YYYY-MM-DD HH:mm", zone);
        if (reserved) startTime = startTime.subtract(5, "minute");

        const endTime = dayjs.tz(`${datePart} ${meetingEndTime}`, "YYYY-MM-DD HH:mm", zone);
        const now = dayjs().tz(zone);

        const today = now.startOf("day");
        const meetingDay = dayjs(meetingDate).tz(zone).startOf("day");

        setIsEnabled(today.isSame(meetingDay));
        setIsCPCStarted(!reserved && now.isAfter(startTime));

        return { now, startTime, endTime };
    };

    // -------------------------------
    // Set Errors
    // -------------------------------
    if (!quizInfo.reserved && location?.pathname === "/cpcregistration") {
        setError("Please Reserve your spot");
    } else if (!quizInfo.reserved) {
        setError("Please Reserve your spot");
    } else if (quizInfo.participated && quizInfo.reserved) {
        setError("You have already participated");
    }

    // -------------------------------
    // Initial check
    // -------------------------------
    const { now: nowCPC, sstartTime, sendTime } = cpcEnableCheck();
    const { now: nowMeeting, startTime, endTime } = checkMeetingTime();

    // -------------------------------
    // Setup timers
    // -------------------------------
    const timers = [];

    // Timer for CPC start
    if (sstartTime && nowCPC && sstartTime.isAfter(nowCPC)) {
        const diffStart = sstartTime.diff(nowCPC);
        timers.push(setTimeout(() => {
            console.log("CPC start reached");
            setIsCPCEnabled(true);
        }, diffStart));
    }

    // Timer for CPC end
    if (sendTime && nowCPC && sendTime.isAfter(nowCPC)) {
        const diffEnd = sendTime.diff(nowCPC);
        timers.push(setTimeout(() => {
            console.log("CPC end reached");
            setIsCPCEnabled(false);
            setIsCPCEnded(true);
        }, diffEnd));
    }

    // Timer for meeting start
    if (startTime && nowMeeting && startTime.isAfter(nowMeeting)) {
        const diffMeetingStart = startTime.diff(nowMeeting);
        timers.push(setTimeout(() => {
            console.log("Meeting start reached");
            setIsCPCStarted(true);
        }, diffMeetingStart));
    }

    // Timer for meeting end
    if (endTime && nowMeeting && endTime.isAfter(nowMeeting)) {
        const diffMeetingEnd = endTime.diff(nowMeeting);
        timers.push(setTimeout(() => {
            console.log("Meeting end reached");
            setIsCPCStarted(false);
        }, diffMeetingEnd));
    }

    // Cleanup
    return () => {
        timers.forEach((t) => clearTimeout(t));
    };

}, [quizInfo, timeZone, location?.pathname]);
    function onConfirm() {
        setShowAlert(false)
    };

    const loadRazorpay = async () => {
        console.log("Initiating Razorpay Payment...");
console.log("Quiz Info:", quizInfo);
        try {
            let id = quizInfo?.id;
            let amount = Number(quizInfo?.cost) * 100;
            if (!id) {
                let res = await tmdbApi.cpcPayments(quizInfo?.cpcid);
                id = res?.result?.razorpayOrder?.id;
                amount = res?.result?.razorpayOrder?.amount;
            }
            const paymentAmount = amount;
            const paymentCurrency = "INR";

            // const paymentKey = RAZORPAY_KEY_ID;
            const options = {
                key: razorpayKey,
                amount: paymentAmount,
                currency: paymentCurrency,
                display_currency: "INR",

                name: "Dadi",
                description: quizInfo?.title || "CPC Payment",
                order_id: id,
                handler: async function (response) {
                    console.log(response);
                    console.log("Razorpay Response:", response);

                    // Handle success/error response here
                    let signature = response?.razorpay_signature;
                        console.log("Signature:", signature);

                    // Fallback: try to get signature from window or other sources if not present
                    if (!signature && window?.razorpay_signature) {
                        signature = window.razorpay_signature;
                    }
                    // Always send signature, even if empty string
                    let obj = {
                        razorpay_payment_id: response?.razorpay_payment_id || "",
                        razorpay_order_id: response?.razorpay_order_id || "",
                        razorpay_signature: signature || "",
                    };
                    // Only treat as success if both payment_id and signature are present
                    const isPaymentSuccess = !!(response?.razorpay_payment_id && signature);
                        console.log("Is Payment Success:", isPaymentSuccess);

                    if (isPaymentSuccess) {
                        obj.message = "Payment successful";
                        let verificationData = await tmdbApi.verifyPayments(quizInfo?.cpcid, quizInfo?.moduleid, JSON.stringify(obj), id);
                        if (
                            response?.razorpay_order_id &&
                            verificationData?.result?.gatewayPaymentId &&
                            verificationData?.statusCode === 200
                        ) {
                            navigate("/instructions/" + quizInfo.cpcid);
                        } else {
                            setErrorMsg(true);
                            return;
                        }
                    } else {
                        // Add error reason if available
                        let reason = response?.error || response?.reason || "Payment failed or was cancelled.";
                        let failed = {
                            message: `Payment failed: ${reason}`,
                        };
                        await tmdbApi.verifyPayments(quizInfo?.cpcid, quizInfo?.moduleid, JSON.stringify(failed), id, "FAILED");
                        setErrorMsg(true);
                        return;
                    }


                },
                prefill: {
                    name: localStorage.getItem("name") || "User Name",
                    email: localStorage.getItem("email") || "",
                    contact: localStorage.getItem("contact") || "9999999999",
                },
                notes: {
                    address: localStorage.getItem("email"),
                },
                theme: {
                    color: "#3399cc",
                },
                modal: {
                    ondismiss: async function () {
                                console.warn("Payment Modal Closed by User");
                        // Handle payment modal close/cancel
                        let failed = {
                            message: `Payment Cancelled`,
                        };
                        await tmdbApi.verifyPayments(quizInfo?.cpcid, quizInfo?.moduleid, JSON.stringify(failed), id, "CANCELLED");
                        setErrorMsg(true);
                        return;
                    }
                }
            };
            if (window.Razorpay) {
                const rzp = new window.Razorpay(options);
                rzp.open();
            } else {
                alert("Razorpay SDK not loaded");
            }
        } catch (err) {
            alert("Failed to initiate payment");
            console.error(err);
        }
    };

    const handlePreQuizClick = () => {
    console.log("Pre-CPC button clicked");

    if (quizInfo?.participated) {
        setAlertTitle("You have already participated in this Pre-CPC Quiz.");
        setShowAlert(true);
        return;
    }

    if (!isCPCEnabled) {
        const start = `${displayDate(quizInfo?.scheduleDate)} ${convertToAMPM(quizInfo?.scheduleStartTime)}`;
        // const end = `${displayDate(quizInfo?.scheduleEndDate)}, ${convertToAMPM(quizInfo?.scheduleEndTime)}`;

        setAlertTitle(
            `Pre-CPC Quiz will start from ${start} IST.`
        );
        setShowAlert(true);
        return;
    }

    if (isCPCEnded) {
        setAlertTitle("Pre-CPC Quiz has already ended.");
        setShowAlert(true);
        return;
    }

    // If everything valid → proceed
    join();
};
    const join = async () => {
        console.log("Join button clicked");
        console.log("User Type:", userData?.userType);
//  setloading(true)
        if (!["doctor", "admin"].includes(userData?.userType?.toLowerCase())) {
            console.warn("User not eligible");
            setShowAlert(true);
            return;
        }

        console.log("Quiz Reserved:", quizInfo?.reserved);
        console.log("Quiz Cost:", quizInfo?.cost);
        console.log("Purchased:", quizInfo?.purchased);

        if (quizInfo?.reserved) {
            const isFree = quizInfo?.cost === "0" || !quizInfo?.cost;
            console.log("Is Free Quiz:", isFree);

            if (isFree || quizInfo?.purchased) {
                console.log("Navigating to instructions page");
                navigate("/instructions/" + quizInfo.cpcid);
            } else {
                console.log("Paid quiz, initiating Razorpay...");
                await loadRazorpay();
            }
        } else {
            setloading(true)
            console.log("User not reserved, adding participant...");
            addCPCParticipant();
        }
    };

    const addCPCParticipant = async () => {
        try {
            const res = await tmdbApi.addCpcParticipants({ cpcid: quizInfo?.cpcid });
            setSuccessMsg('You have successfully reserved your spot');


            setSuccessDisplay(true);
        } catch (err) {
            console.error(err);
        }finally{
            setloading(false)
        }
    };

    const convertToAMPM = (time24) => {
        const date = new Date();
        if (time24) {
            const [hour, minute] = time24.split(":").map(Number);
            date.setHours(hour, minute);
        }
        return date.toLocaleTimeString("en-IN", {
            hour: "numeric", minute: "2-digit", hour12: true
        });
    };

    const displayDate = (date) => {
        return new Date(date).toLocaleDateString("en-US", {
            year: "numeric", month: "long", day: "numeric"
        });
    };
    const login = () => {
        localStorage.setItem("cpcid", quizInfo?.cpcid);

        if (!token) {
            localStorage.setItem("userType", "STUDENT");
            navigate("/login");
        } else {
            if (userData?.userType === "DOCTOR") {
                navigate("/cpc");
            } else {
                setShowAlert(true); // show "You are not eligible" or similar message
            }
        }

    }


    const refresh = () => {
        setSuccessDisplay(false);
        setError(successMsg?.toLowerCase().includes("spot") ? "Pre-CPC Quiz of the month" : successMsg);
        getCpcInfo();
    };

    const joinMeeting = async () => {
    console.log("Join Meeting Clicked");
    console.log("isEnabled:", isEnabled);
    console.log("Purchased:", quizInfo?.purchased);
    console.log("Cost:", quizInfo?.cost);

    if (isEnabled) {
        console.log("Meeting is enabled");

        if (quizInfo?.cost === "0" || !quizInfo?.cost) {
            console.log("Free meeting, opening link");
            await tmdbApi.joinMeetingCount();
            window.open(quizInfo?.meetingLink, "_blank");
        } else {
            if (quizInfo.purchased) {
                console.log("Paid and purchased, opening link");
                await tmdbApi.joinMeetingCount();
                window.open(quizInfo?.meetingLink, "_blank");
            } else {
                console.warn("Paid meeting but not purchased");
                setErrorMsg(true);
            }
        }
    } else {
        console.warn("Meeting not started yet");
        setShowWaiting(true);
    }
};

    const amoutFrmt = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            maximumFractionDigits: 0,
        }).format(amount);
    };

    const disablePreQuiz = () => quizInfo.participated || !isCPCEnabled;

    // const spotsLeft = quizInfo?.maxspots - (quizInfo?.reservedspots || 0);

    useEffect(() => {
        let loc = localStorage.getItem("loc");
        loc = JSON.parse(loc);
        let timeZoneTmp = "Asia/Kolkata";
        const viewerTimeZone = loc?.headers?.["cloudfront-viewer-time-zone"];
        if (viewerTimeZone && viewerTimeZone.length > 0 && viewerTimeZone[0]?.value) {
            timeZoneTmp = viewerTimeZone[0].value;
        }
        setTimeZone(timeZoneTmp)
    }, [])

    return (
        <>
            <div className={`${!timer ? "col-lg-6" : "col-lg-6"} col-md-6 session-content`}>
                <h3 className="sub_title">{quizInfo?.title}</h3>
                <p className="mb-4 cpc-para" dangerouslySetInnerHTML={{ __html: quizInfo?.description }} ></p>
                <div className="session-details">
                    <img src={location?.pathname === "/cpcregistration" ? cpcCalendar : calendar} className="mb-3 calendar_icon" width="44" />
                    <p>{displayDate(quizInfo?.meetingDate)}</p>
                </div>


                {(
                    <div className="session-details">
                        <img src={location?.pathname === "/cpcregistration" ? cpcClock : clockIcon} className="mb-3" width="42" />
                        <p>
                            {`${convertToAMPM(quizInfo?.meetingStartTime)} to ${convertToAMPM(quizInfo?.meetingEndTime)} IST | Live Online`}
                        </p>
                    </div>
                )}


                <div className="d-flex align-items-center flex-wrap student-cpc">
                    <div className="d-flex justify-content-start align-items-center gap-3">
                        {location.pathname === "/cpcregistration" ? <>
                            {token && quizInfo?.reserved && (
                                // <button className="btn-fill-icon" onClick={joinMeeting}>
                                //     <span className="material-symbols-outlined btn-icon-fill-style">keyboard_arrow_right</span>
                                //     Join Meeting
                                // </button>
                                <a className="register-link" target="_blank">
                                    <button className="btn-fill-join-icon" onClick={joinMeeting}><span className="material-symbols-outlined btn-icon-fill-style">keyboard_arrow_right</span>Join Meeting</button>
                                </a>
                            )}
                        </> : <>
                            {token && quizInfo?.reserved && (
                                <><button className="btn-fill-icon" onClick={joinMeeting}>
                                    <span className="material-symbols-outlined btn-icon-fill-style">keyboard_arrow_right</span>
                                    Join Meeting
                                </button>
                                </>
                            )}
                        </>}




                        {location?.pathname === "/cpcregistration" ? <>
                            {token && !isCPCEnded && quizInfo && quizInfo?.reserved && !quizInfo?.participated && quizInfo?.cases?.length !== 0 && (

                                <a className="register-link" target="_blank">
                                    <button className="btn-fill-icon" onClick={join} disabled={disablePreQuiz()}><span className="material-symbols-outlined btn-icon-fill-style">keyboard_arrow_right</span> Pre-CPC Quiz of the month</button>
                                </a>
                            )}
                        </> : <>
                            {token && !isCPCEnded && quizInfo && quizInfo?.reserved && !quizInfo?.participated && quizInfo?.cases?.length !== 0 && (
                                <button className="btn-stroke-icon"
                                //  onClick={join} 
                                 onClick={handlePreQuizClick}
                                // disabled={disablePreQuiz()}
                                
                                >
                                    <span className="material-symbols-outlined btn-icon-stroke-style">keyboard_arrow_right</span>
                                    Pre-CPC Quiz of the month
                                </button>
                            )}
                        </>}
                    </div>








                    {location.pathname === "/cpcregistration" ? <>
                        {!isCPCStarted && !["You have already participated", "Pre-CPC Quiz of the month"].includes(error) && token && (

                            <>
                                <a className="register-link" target="_blank">
                                    <button className="btn-fill-icon" onClick={join}><span className="material-symbols-outlined btn-icon-fill-style">keyboard_arrow_right</span>{error}</button>
                                </a>

                                {
                                    quizInfo?.scheduleDate && !isCPCEnded && quizInfo && !quizInfo?.participated && quizInfo?.cases?.length !== 0 && <div className="d-flex align-items-center gap-3 flex-wrap student-cpc">


                                        <div className="fw-bold note sub-note">
                                            {`Pre-CPC Quiz available from ${displayDate(quizInfo?.scheduleDate)} ${convertToAMPM(quizInfo?.scheduleStartTime)} to ${displayDate(quizInfo?.scheduleEndDate)} ${convertToAMPM(quizInfo?.scheduleEndTime)} IST${quizInfo?.cost ? ` JOIN for INR ${amoutFrmt(quizInfo?.cost)}` : ''}`}
                                        </div></div>}

                            </>





                        )}
                    </> : <>
                        {!isCPCStarted && !["You have already participated", "Pre-CPC Quiz of the month"].includes(error) && token && (
                                <button className="btn-stroke-icon" onClick={join} disabled={loading}>
                                    {loading && (
                                        <img src={rotate_right_cpc} 
                                        
                                      className="loading-icon btn-icon-stroke-style material-symbols-outlined" id="NextLoginLoading"  alt="loading"
                                        
                                        />
                                    )}{!loading && <span className="material-symbols-outlined btn-icon-stroke-style">keyboard_arrow_right</span>}
                                    {error}
                            </button>
                        )}
                    </>}

                </div>



                <div className="d-flex align-items-center gap-3 flex-wrap student-cpc">

                    {location?.pathname === "/cpcregistration" ? <>
                        {!quizInfo?.reserved && !quizInfo?.participated && !isCPCStarted && !token && (

                            <div>
                                <a className="register-link mb-2" target="_blank">
                                    <button className="btn-fill-icon" onClick={login}><span className="material-symbols-outlined btn-icon-fill-style">keyboard_arrow_right</span> Please Reserve your Spot</button>
                                </a>
                                <div className="mt-2">

                                    {quizInfo?.scheduleDate && !isCPCEnded && quizInfo && !quizInfo?.participated && quizInfo?.cases?.length !== 0 && <div className="d-flex align-items-center gap-3 flex-wrap student-cpc">
                                        <div className="fw-bold note sub-note">
                                            {`Pre-CPC Quiz available from ${displayDate(quizInfo?.scheduleDate)} ${convertToAMPM(quizInfo?.scheduleStartTime)} to ${displayDate(quizInfo?.scheduleEndDate)} ${convertToAMPM(quizInfo?.scheduleEndTime)} IST${quizInfo?.cost ? ` JOIN for INR ${amoutFrmt(quizInfo?.cost)}` : ''}`}
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        )}
                    </> : <>
                        <div>

                            {!quizInfo?.reserved && !quizInfo?.participated && !isCPCStarted && !token && (
                                <button className="btn-stroke-icon" onClick={login}>
                                    <span className="material-symbols-outlined btn-icon-stroke-style">keyboard_arrow_right</span>
                                    Please Reserve your Spot
                                </button>
                            )}

                            <div className="mt-2">
                                {quizInfo?.scheduleDate && !isCPCEnded && quizInfo && !quizInfo?.participated && quizInfo?.cases?.length !== 0 && <div className="d-flex align-items-center gap-3 flex-wrap student-cpc">
                                    <div className="fw-bold note sub-note higlighted-text">
                                        {`Pre-CPC Quiz available from ${displayDate(quizInfo?.scheduleDate)} ${convertToAMPM(quizInfo?.scheduleStartTime)} to ${displayDate(quizInfo?.scheduleEndDate)} ${convertToAMPM(quizInfo?.scheduleEndTime)} IST${quizInfo?.cost ? ` JOIN for INR ${amoutFrmt(quizInfo?.cost)}` : ''}`}
                                    </div>
                                </div>}


                            </div>
                        </div></>}

                </div>
                <div className="fw-bold note sub-note"><span className="sub-note-span">Note: </span>Please note that recording of CPC only available for people who participate and submit the quiz.</div>



            </div>

            {/* <SweetAlert
                show={successMsgDisplay}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={successMsg}
                customclassName="cpc-alert"
                onConfirm={refresh}
                id="success-alert"
            /> */}
            <SweetAlert
                show={successMsgDisplay}
                // show={true}
                custom
                // customclassName="cpc-alert"
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                // title={successMsg}
                title={'You have successfully reserved your spot'}
                onConfirm={refresh}
                customclassName="cpc-alert"
                // id="success-alert"
            />
            <SweetAlert
                show={showAlert}
                custom
                customclassName="cpc-alert"
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={"You are not eligible to access this section"}
                onConfirm={e => onConfirm()}
                id="success-alert"
            />
            <SweetAlert
                show={errorMsg}
                custom
                customclassName="cpc-alert"
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title="payment failed or cancelled"
                onConfirm={() => okayErrorFn()}
                id="error-alert"
            />
            <SweetAlert
    show={showAlert}
    custom
    customclassName="cpc-alert"
    confirmBtnText="OK"
    confirmBtnBsStyle="primary"
    title={alertTitle}
    onConfirm={() => setShowAlert(false)}
/>
            <SweetAlert
                show={showWaiting}
                custom
                customclassName="cpc-alert"
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title="You can join the meeting once the scheduled time is reached."
                onConfirm={() => setShowWaiting(false)}
                id="error-alert"
            />
        </>
    )
};

export default DescCPCBlock;